import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { processTag } from "../../audio_player/Player";
import { getEpisode } from "@store/action/planning/EpisodeAction";
import cover from "@src/assets/images/music.png";
import classnames from "classnames";
import { addMusic } from "@src/redux/action/player/PlayerBackOfficeAction";
import { Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useIcecast } from "@hooks/useIcecast";

const AudioPlayer = () => {
  const { icecastData, host } = useIcecast();
  const onAir =
    icecastData?.artist === "live" && icecastData?.title.startsWith(host);
  const { t } = useTranslation();
  const PlayerBackOfficeReducer = useSelector(
    (state) => state.PlayerBackOfficeReducer
  );
  const dispatch = useDispatch();
  const [isloadind, setIsloadind] = useState(false);
  const [playerPause, setPlayerPause] = useState(true);
  const isPaused = () => {
    setPlayerPause(true);
  };
  const isPlayed = () => {
    setPlayerPause(false);
  };

  const epSelected_ID = JSON.parse(localStorage.getItem("episode_info"));
  const currentSong = PlayerBackOfficeReducer.currentSong;
  const songimg = PlayerBackOfficeReducer.songimg
    ? PlayerBackOfficeReducer.songimg
    : onAir
    ? icecastData?.title?.match(/emission_piture- (.*?) -emission_piture/)[1]
    : cover;

  const namesong = PlayerBackOfficeReducer.namesong
    ? PlayerBackOfficeReducer.namesong
    : onAir
    ? icecastData?.title?.match(/-emission_piture(.*)/)[1]
    : `${icecastData?.artist} - ${icecastData?.title}`;
  const peak_listeners = icecastData?.listener_peak;

  const audioVuexy = document.getElementById("audioVuexy");
  const data_plyr_fullscreen = document.querySelectorAll(
    '[data-plyr="fullscreen"]'
  );
  const plyr__videowrapper = document.getElementsByClassName(
    "plyr__video-wrapper"
  );
  const checkIsActive = data_plyr_fullscreen[0]?.getAttribute("aria-pressed");
  useEffect(() => {
    const nodes = document.querySelectorAll("#audioVuexy");
    plyr.setup(nodes, {
      controls: [
        "rewind",
        "play",
        "fast-forward",
        "progress",
        "current-time",
        "duration",
        "mute",
        "volume",
        "fullscreen",
      ],
    });
  }, []);
  useEffect(() => {
    const nodes = document.querySelectorAll("#audioVuexy");
    nodes.forEach(processTag);

    var xhttp = new XMLHttpRequest();
    var searchString = "#EXT-X-STREAM-INF";
    xhttp.onreadystatechange = function () {
      var test =
        xhttp.responseText.indexOf(searchString) > -1
          ? "has string"
          : "does not have string";
      if (test == "has string") {
        var hls = new Hls();
        hls.loadSource(currentSong);

        hls.attachMedia(audioVuexy);
      }
    };
    xhttp.open("GET", currentSong, true);
    // xhttp.send();
  }, [audioVuexy, currentSong]);
  useEffect(() => {
    if (playerPause) {
      audioVuexy?.pause();
      onpenVideoPlayer("none");
    } else {
      if (PlayerBackOfficeReducer.has_video) {
        onpenVideoPlayer("block");
      } else {
        onpenVideoPlayer("none");
      }
      audioVuexy?.play();
      audioVuexy.volume = 0.5;
    }
  }, [playerPause, audioVuexy]);
  useEffect(() => {
    if (PlayerBackOfficeReducer.has_video) {
      onpenVideoPlayer("block");
    } else {
      onpenVideoPlayer("none");
    }
  }, [PlayerBackOfficeReducer]);
  const onpenVideoPlayer = (x) => {
    for (var i = 0; i < plyr__videowrapper.length; i++) {
      plyr__videowrapper[i].style.display = x;
    }
  };
  const onpenVideoFullScreen = (x) => {
    for (var i = 0; i < plyr__videowrapper.length; i++) {
      plyr__videowrapper[i].style.top = x;
    }
  };
  useEffect(() => {
    if (checkIsActive == "true") {
      onpenVideoFullScreen(0);
    } else {
      if (window.innerWidth > 480) {
        onpenVideoFullScreen("-250px");
      } else {
        onpenVideoFullScreen("inherit");
      }
    }
  }, [data_plyr_fullscreen, checkIsActive]);

  useEffect(() => {
    if (data_plyr_fullscreen?.length) {
      if (audioVuexy?.src || audioVuexy?.srcObject) {
        data_plyr_fullscreen[0].style.cssText =
          PlayerBackOfficeReducer.is_web_rtc
            ? "display:none !important"
            : "display:block !important";
      } else {
        data_plyr_fullscreen[0].style.cssText = "display:none !important";
      }
    }
  }, [audioVuexy, data_plyr_fullscreen, PlayerBackOfficeReducer]);

  useEffect(() => {
    epSelected_ID && dispatch(getEpisode(epSelected_ID));
  }, [epSelected_ID]);

  const RadioReducer = useSelector((state) => state.RadioReducer);
  const music_icecast = RadioReducer?.single?.icecast_url_streaming;
  const music_hls = RadioReducer?.single?.hls_url_streaming;
  const data = {
    currentsong: music_hls ? music_hls : music_icecast,
    downoladUrl: null,
    namesong: null,
    songimg: null,
    item_data: null,
  };
  const playAudio = () => {
    if (!isloadind && audioVuexy) {
      dispatch(addMusic(data));
      const playPromise = audioVuexy.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {}).catch((error) => {});
      }
      setIsloadind(true);
    } else {
      return;
    }
  };
  const stopAudio = () => {
    dispatch(
      addMusic({
        downoladUrl: null,
        namesong: null,
        songimg: null,
        playlist: [],
      })
    );
    isPaused();
    audioVuexy.pause();
  };
  return (
    <div
      className={classnames("adonis-player-wrap", {
        backOffice: true,
      })}
    >
      <div
        id="adonis_jp_container"
        className="master-container-holder"
        role="application"
        aria-label="media player"
      >
        <div
          className={classnames("adonis-player-horizontal", {
            backoffice: true,
          })}
        >
          <div className="master-container-fluid">
            <div className="row adonis-player">
              <div
                className="col-sm-4 col-lg-4 col-xl-4 col-5"
                style={{ position: "relative" }}
              >
                <div className="media current-item">
                  <div className="song-poster p-1">
                    <img
                      className="box-rounded-sm"
                      src={songimg ? songimg : cover}
                    />
                  </div>
                  <div className="des">
                    <p className="artist-name">
                      <a>{icecastData ? namesong : ""}</a>
                    </p>
                  </div>
                  <div className="des_option_wrapper listenBack p-2">
                    {isloadind ? (
                      <a className="buttonlive" style={{ textAlign: "center" }}>
                        <Spinner color="danger" size="sm" />
                      </a>
                    ) : (
                      <a
                        className="buttonlive"
                        onClick={() => {
                          !isloadind && playerPause ? playAudio() : stopAudio();
                        }}
                      >
                        <div className="livestop">
                          {!isloadind && playerPause ? (
                            <Fragment>
                              <p>Live</p>
                              <span className="live-icon"></span>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <p>Stop</p>
                              <span className="stop-icon"></span>
                            </Fragment>
                          )}
                        </div>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-1 col-lg-1 col-xl-1 col-1 resp mt-1 p-1 peak_listeners">
                {t("Peak listeners")}: {peak_listeners}
              </div>
              <div className="col-sm-7 col-lg-7 col-xl-7 col-5 resp setting_player_div">
                <div className="TuneInPlayer">
                  <video
                    id="audioVuexy"
                    src={currentSong}
                    autoPlay={currentSong ? true : false}
                    onPause={() => {
                      isPaused();
                      setIsloadind(false);
                      audioVuexy.style.cssText = "display:none !important";
                    }}
                    onPlay={() => {
                      isPlayed();
                      setIsloadind(false);
                      audioVuexy.style.cssText = "display:block !important";
                    }}
                    onCanPlay={() => {
                      isPlayed();
                      setIsloadind(false);
                    }}
                    controls
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;
